import initAccordion from "../components/core/Accordion/Accordion.js";

document.addEventListener("DOMContentLoaded", function () {
  initAccordion();
  mobileMenu();
});

function mobileMenu() {
  const mobileMenu = document.querySelector(".main-nav");
  const mobileMenuBtn = document.querySelector(".mobile-menu-btn");
  const mobileMenuCloseBtn = document.querySelector(".mobile-menu-close-btn");

  if (mobileMenuBtn) {
    mobileMenuBtn.addEventListener("click", () => {
      mobileMenu.classList.add("nav-show");
      document.documentElement.classList.add("menu-open");
      document.body.classList.add("menu-open");
    });
  }

  if (mobileMenuCloseBtn) {
    mobileMenuCloseBtn.addEventListener("click", () => {
      mobileMenu.classList.remove("nav-show");
      document.documentElement.classList.remove("menu-open");
      document.body.classList.remove("menu-open");
    });
  }

  document.addEventListener("click", (e) => {
    const clickedInsideMenu = mobileMenu.contains(e.target);
    const clickedButton = mobileMenuBtn.contains(e.target);

    if (!clickedInsideMenu && !clickedButton) {
      mobileMenu.classList.remove("nav-show");
      document.documentElement.classList.remove("menu-open");
      document.body.classList.remove("menu-open");
    }
  });
}
